class State {
  constructor () {
    this.database = {}
  }
}

const state = new State()

export function useState () {
  return state.database
}

export function setState (key, value) {
  state.database[key] = value
  return state.database
}

export function exposeState (key, initial) {
  if (state.database[key] === undefined) state.database[key] = initial
  return state.database
}

export function replaceState (newState) {
  for (const key in state.database) delete state.database[key]
  for (const key in newState) state.database[key] = newState[key]
  return state.database
}

export function saveState () {
  localStorage.setItem('__gameState', JSON.stringify(state.database))
}

export function restoreSaveState () {
  try {
    const json = localStorage.getItem('__gameState')
    const data = JSON.parse(json)
    replaceState(data)
    return true
  } catch {
    return false
  }
}

export function clearSaveState () {
  localStorage.removeItem('__gameState')
}

export function serializeState () {
  return JSON.parse(state.database)
}
